<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div v-if="checkItems" class="banner">
          <a :href="url" v-if="item.url" target="_blank">
            <img :src="item.image">
          </a>
          <img :src="item.image" v-else>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../../helpers/api';

  export default {
    props: ['bloco'],
    data() {
      return {
        title: 'Galeria de imagem',
        item: [
          {
            image: '',
            url: null
          }
        ]
      }
    },
    created() {
      if (this.bloco.nome) {
        this.title = this.bloco.nome;
      }
      let self = this;
      get('content/' + this.bloco.id).then(function (response) {
        // self.item = window.siteconfig.result.data.imagem;
        self.item = response.data.result.data;
      });
    },
    computed: {
      checkItems() {
        return this.item.image !== '';
      },
      url () {
        return this.item.url !== null
                ? this.item.url
                : 'javascript:void(0);'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/home/ImageGalleryList.vue